import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {User} from "../type/user";
import {UserRole} from "../type/user-role";

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
})
export class UserEditComponent implements OnInit {
    node = 'user';
    roleNode = 'user-role';

    user:User = User;
    userRoles:[UserRole] = [UserRole];

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private route: ActivatedRoute,
        private location: Location
    ) {}

    ngOnInit(): void {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.user = response.json().data[0];
                        });
                    this.getUserRoles();
                }
            );
    }

    getUserRoles(): void {
        this.apiService.getAll(this.roleNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.userRoles = [UserRole];
                } else {
                    this.userRoles = response.json().data;
                }
            });
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.user.user_id], this.user)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    alert('Error: Unable to submit form');
                } else {
                    alert('Success: User updated successfully');
                    this.location.back();
                }
            },
            (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/users/user-edit.component.ts